<div class="main-content userDashboard">
    <div class="row">
        <div class="col-12 ">
            <mat-card class="dashboard-card-wrapper">
                <mat-card-content>
                    <div class="container mainContentNew">
                        <div>
                            <h2>Dashboard <mat-icon [matTooltip]="'Reload CertWallet tour'" class="reload-tour-button" (click)="reloadTour()" >help</mat-icon></h2>
                        </div>
                        <div class="d-flex justify-content-between">
                            <span class="d-block dashboard-description">Overview of key updates and activities to help you stay informed and organized</span>
                            <ul class="breadcrumb">
                                <li class="active"><a class="text-black" [routerLink]="['/dashboard']">Home</a></li>
                                <li class="separator">/</li>
                                <li><a href="#">Dashboard</a></li>
                            </ul>
                        </div>
                        <hr />
                    </div>
                    <div class="container mt-5">
                        <div class="row">
                            <div class="col-12 col-md-12 col-lg-4 col-sm-12">
                                <div class="row">
                                    <div class="col-12">
                                        <div id="step1" class="accountCard mt-3">
                                            <div class="d-flex justify-content-between mt-3">
                                                <div class="d-flex d-inline-block">
                                                    <mat-icon class="round-icon accountCard-icon">account_circle</mat-icon>
                                                    <h5 class="mt-2 text-white">Account Status</h5>
                                                </div>
                                                <span *ngIf="accountStatusCard.expired == 'no'" class="badge accountCard-badge-active" >Active</span>
                                                <span *ngIf="accountStatusCard.expired == 'yes'" class="badge accountCard-badge-inactive" >Not Active</span>

                                            </div>
                                            <div class="accountCard-value">
                                                <h3 class="mt-5 mb-4 first-letter-uppercase accountCard-value text-white" >
                                                    {{ (accountStatusCard.product)? ui.capitalizeFirstLetter(accountStatusCard.product): "" }}
                                                </h3>
                                            </div>
                                            <div class="text-white mt-5 d-flex justify-content-between">
                                                <ng-container *ngIf="accountStatusCard.plan == 'month'">
                                                    <div class="mt-3" *ngIf="accountStatusCard.planCount == 1">Monthly subscription</div>
                                                    <div class="mt-3" *ngIf="accountStatusCard.planCount == 3">Quarterly subscription</div>
                                                    <div class="mt-3" *ngIf="accountStatusCard.planCount == 12">Annual subscription</div>
                                                </ng-container>
                                                <ng-container *ngIf="accountStatusCard.plan == 'year'">
                                                    <div *ngIf="accountStatusCard.planCount == 1">Annual subscription</div>
                                                </ng-container>

                                                <div class="mt-3">Exp: {{ accountStatusCard.expirationDate }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div id="step3" class="certificateCard mt-3">
                                            <div class="d-flex  mt-3">
                                                <mat-icon class="round-icon certificateCard-icon">description</mat-icon>
                                                <h5 class="mt-2 text-white">Number of Certifications</h5>
                                            </div>
                                            <div class="certificateCard-value">
                                                <h3 class="mt-5 mb-5 first-letter-uppercase certificateCard-value text-white">{{ numberOfCertCard?.count }}</h3>
                                            </div>
                                            <div class="text-white mt-5 d-flex justify-content-between">
                                                <div class="mt-3">Active: {{numberOfCertCard.active}}</div>
                                                <div class="mt-3" style="margin-left: 20px;">Expired: {{numberOfCertCard.expired}}</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="col-12 col-md-12 col-lg-4 col-sm-12">
                                <div class="row">
                                    <div class="col-12">
                                        <div id="step2" class="dueSoonCard mt-3">
                                            <div class="d-flex justify-content-between">
                                                <div class="d-flex justify-content-between mt-3">
                                                    <mat-icon class="round-icon dueSoonCard-icon">timer</mat-icon>
                                                    <h5 class="mt-2 text-white">Expiring within 60 days</h5>
                                                </div>
                                                <div class="mt-3">
                                                    <span class="badge badge-count-dueSoon">
                                                        {{ reminders.dueSoon.length }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="starterHeading">
                                                <div class="mt-4 w-100">
                                                    <span class="text-white">Needs to Renew in:</span>
                                                    <h3 class="text-white dueSoonCard-value" *ngIf="reminders.dueSoon.length > 0">
                                                        {{ dateHelper.expiredIn(reminders?.dueSoon[0].expiresDate) }}
                                                    </h3>
                                                </div>
                                            </div>
                                            <div class="text-white mt-5 mb-2 text-light set-expire-label">
                                                Certification Set to Expire:
                                            </div>
                                            <div class="text-white d-flex justify-content-between">
                                                <span class="ellipsis-title">{{ reminders?.dueSoon[0]?.certification?.certificationTitle }}</span>
                                                <div *ngIf="reminders.dueSoon.length > 0">
                                                    {{reminders.dueSoon[0].expiresDate | date : 'MM/dd/y'}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div id="step4" class="futureRenewalCard mt-3">
                                            <div class="d-flex justify-content-between">
                                                <div class="d-flex justify-content-between mt-3 mb-3">
                                                    <mat-icon class="round-icon futureRenewalCard-icon">schedule</mat-icon>
                                                    <h5 class="mt-2 text-white">Future Renewals</h5>
                                                </div>
                                                <div class="mt-3 mb-3">
                                                    <span class="badge badge-count-futureRenewal" >
                                                        {{ numberOfCertCard?.future }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="mt-2">
                                                <div class="mt-2 mb-3 w-100">
                                                    <span class="text-white">Expires in: </span>
                                                    <h3 class="futureRenewalCard-value text-white" *ngIf="reminders.future.length > 0">
                                                        {{ date.expiredIn(reminders?.future[0].expiresDate) }}
                                                    </h3>
                                                </div>
                                            </div>
                                            <div class="text-white mt-5 mb-2">
                                                Certification to Expire Next:
                                            </div>
                                            <div class="text-white d-flex justify-content-between">
                                                <span class=" ellipsis-title">{{ reminders?.future[0]?.certification?.certificationTitle }}</span>
                                                <div *ngIf="reminders.future.length > 0">
                                                    {{reminders.future[0].expiresDate | date: 'MM/dd/y'}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-12 col-lg-4 col-sm-12" id="step5">
                                <div class="reminderCard mt-3 d-none d-sm-none d-md-none d-lg-block" >
                                    <div class="d-flex mt-3">
                                        <mat-icon class="round-icon reminderCard-icon">notifications</mat-icon>
                                        <h5 class="mt-2 text-white">Reminders</h5>
                                    </div>

                                    <ng-container *ngIf="notifications.length > 0; else elseReminder">
                                        <div class="reminderCard-insider">
                                            <div class="card notification-card" *ngFor="let d of notifications">
                                                <div class="card-body" (click)="viewDetailNotification(d)">
                                                    <div class="mb-2">
                                                        <b>{{d.subject}}</b>
                                                    </div>
                                                    <div class="mb-3 ellipsis">
                                                        {{d.message}}
                                                    </div>

                                                    <span>{{ d.timeAgo }}.</span>
                                                </div>
                                            </div>

                                        </div>


                                    </ng-container>
                                    <ng-template #elseReminder>
                                        <div class="reminderCard-insider">
                                            <div class="card notification-card" >
                                                <div class="card-body">
                                                    You are all caught up!
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>

                                <div class="reminderCard-sm mt-3 d-block d-sm-block d-md-block d-lg-none">
                                    <div class="d-flex mt-3">
                                        <mat-icon class="round-icon reminderCard-icon">notifications</mat-icon>
                                        <h5 class="mt-2 text-white">Reminder</h5>
                                    </div>

                                    <ng-container *ngIf="notifications.length > 0; else elseReminder">
                                        <div class="reminderCard-insider">
                                            <div class="card notification-card" *ngFor="let d of notifications">
                                                <div class="card-body" (click)="viewDetailNotification(d)">
                                                    <div class="mb-2">
                                                        <b>{{d.subject}}</b>
                                                    </div>
                                                    <div class="mb-3 ellipsis">
                                                        {{d.message}}
                                                    </div>

                                                    <span>{{ d.timeAgo }}.</span>
                                                </div>
                                            </div>

                                        </div>


                                    </ng-container>
                                    <ng-template #elseReminder>
                                        <div class="reminderCard-insider">
                                            <div class="card notification-card" >
                                                <div class="card-body">
                                                    You are all caught up!
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>

                            <div class="col-12 col-md-12 col-lg-12 col-sm-12">
                                <div class="row mt-4">
                                    <div class="col-12">
                                        <div id="step8" class="bg-white shadow-md p-4" style="border-radius: 10px; border: 1px solid #ccc;">
                                            <div class="row">
                                                <div class="col-md-6 col-sm-12 col-12 col-lg-6">
                                                    <div class="mb-4">
                                                        <h5 class="text-weight-bold" style="color: #5B25B4">Upcoming CEU Training</h5>
                                                        <div class="d-block" style="color: #979797">Discover upcoming CEU training to earn credits</div>
                                                    </div>

                                                </div>
                                                <div class="col-md-6 col-sm-12 col-12 col-lg-6 text-end ">
                                                    <mat-form-field class="mb-4 w-100" appearance="outline">
                                                        <mat-icon matPrefix>search</mat-icon>
                                                        <div class="filters" matSuffix *ngIf="filterTotal > 0; else elseFilterTotalZero">
                                                            <mat-icon class="filters" matSuffix (click)="openAdvanceSearch()">tune</mat-icon>
                                                            <span class="filter-number" matSuffix>{{filterTotal}}</span>
                                                            <mat-icon class="filters" matSuffix (click)="clearFilters()">close</mat-icon>
                                                        </div>
                                                        <ng-template #elseFilterTotalZero>
                                                            <mat-icon matSuffix (click)="openAdvanceSearch()">tune</mat-icon>
                                                        </ng-template>
                                                        <input placeholder="Search" type="text" matInput [(ngModel)]="pageQuery.search" (keyup)="searchCEU($event)">

                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="">
                                                <div class="table-responsive list-wrapper-bordered">
                                                    <table class="table table-striped table-hover table-borderless border-0 ">
                                                        <thead>
                                                        <tr>
                                                            <th class="text-nowrap">CE Provider</th>
                                                            <th class="text-nowrap">CE Type</th>
                                                            <th class="text-nowrap">CE Title</th>
                                                            <th class="text-nowrap text-center">Attendance Type</th>
                                                            <th class="text-nowrap">Event Date</th>
                                                            <th class="text-nowrap text-center">Price</th>
                                                            <th class="text-nowrap">Location</th>
                                                            <th class="text-nowrap" style=" position: sticky; right: -3px; z-index: 2"></th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <ng-container *ngIf="upcomingCeuTraining.length > 0; else elseUpcomingCeu;">
                                                            <tr *ngFor="let d of upcomingCeuTraining; let i = index;">
                                                                <td class="text-nowrap" style="color: #000;"> {{d.provider}}</td>
                                                                <td class="text-nowrap" style="color: #000;"> {{maskingColumn('parameterLabel', 'parameterValue', ceTypeParams.parameterMembers, d.ceType)}}</td>
                                                                <td class="text-nowrap" style="color: #000;"> {{d.title}}</td>
                                                                <td class="text-nowrap text-center" style="color: #000;"> {{maskingColumn('parameterLabel', 'parameterValue', attendanceTypeParams.parameterMembers, d.attendanceType)}}</td>
                                                                <td class="text-nowrap" style="color: #000;"> {{d.startDate | date : "MM/dd/y"}}</td>
                                                                <td class="text-nowrap text-center" style="color: #000;"> $ {{d.cost | number:'1.0-0'}}</td>
                                                                <td class="text-nowrap" style="color: #000;"> {{d.city + ', ' + d.stateOrProvince}}</td>
                                                                <td class="text-nowrap" style="color: #000; position: sticky; right: -3px; z-index: 2">
                                                                    <button [disabled]="disabledButtons[i]" (click)="enroll(d, i)" class="btn btn-purple" style="background: #5B25B4; color: #fff;">Enroll</button>
                                                                </td>
                                                            </tr>
                                                        </ng-container>
                                                        <ng-template #elseUpcomingCeu>
                                                            <tr>
                                                                <td [colSpan]="8" class="text-center" style="color: #000;">No upcoming event</td>
                                                            </tr>
                                                        </ng-template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="mt-4" *ngIf="upcomingCeuTraining.length > 0">
                                                <app-pagination
                                                        (goPage)="toPage($event)"
                                                        (goPerPage)="perPageSet($event)"
                                                        [pagesToShow]="showPages"
                                                        [page]="pageNo"
                                                        [perPage]="pageSize"
                                                        [count]="totalRow"></app-pagination>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-12 col-lg-12 col-sm-12">
                                <div class="targetCreditCard mt-4" id="step6">
                                    <div class="d-flex my-3">
                                        <mat-icon class="round-icon targetCreditCard-icon">alarm_on</mat-icon>
                                        <h5 class="mt-2 text-white">Industry Requirement</h5>
                                    </div>
                                    <div>
                                        <div class="table-responsive table-wrapper-bordered" style="border-radius: 10px;">
                                            <table class="table table-hover table-striped border-top-0" style="border-left: 0; border-right: 0">
                                                <thead>
                                                <tr>
                                                    <th class="text-nowrap">Certification Title</th>
                                                    <th class="text-nowrap text-end">Target</th>
                                                    <th class="text-nowrap text-end">Your Current Status</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <ng-container *ngIf="reminders.all.length > 0; else targetCreditNeeded">
                                                    <tr *ngFor="let d of reminders.all;  index as i">
                                                        <td class="text-nowrap" style="color: #000;"> {{d.certification.certificationTitle}}</td>
                                                        <td class="text-nowrap text-end" style="color: #000;"> {{d.certification.ceuRequired}}</td>
                                                        <td class="text-nowrap text-end" style="color: #000;"> --</td>
                                                    </tr>
                                                </ng-container>
                                                <ng-template #targetCreditNeeded>
                                                    <tr>
                                                        <td [colSpan]="3" class="text-center">No Data</td>
                                                    </tr>
                                                </ng-template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div>

                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-12 col-lg-12 col-sm-12">
                                <div class="scorecardCard mt-5" id="step7">
                                    <div class="mt-3 mb-2 d-block d-sm-block d-md-block d-lg-flex justify-content-between">
                                        <div class="d-flex">
                                            <mat-icon class="round-icon scorecardCard-icon" >verified</mat-icon>
                                            <h5 class="mt-2 text-white">Cyber Combine: Scorecard</h5>
                                        </div>
                                        <div class="d-flex text-end" (click)="goToDetail(scorecard?.id)">
                                            <span *ngIf="scorecard?.id" class="text-white d-block" style="margin-top: 1em">See Detail</span>
                                            <button *ngIf="scorecard?.id"  class="text-white" type="button" mat-icon-button>
                                                <mat-icon class="text-white" >chevron_right</mat-icon>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="table-wrapper-bordered">
                                        <div class="row ">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                                <div class="table-responsive table-wrapper-bordered" style="border-radius: 10px; border: none !important;">
                                                    <h4 class="py-3 px-3">Individual Challenge Scorecard</h4>

                                                    <div class="table-responsive table-wrapper-bordered mx-2">
                                                        <ng-container *ngIf="scorecard && scorecard.individualChallenges && scorecard.individualChallenges.length > 0; else targetIndividual">
                                                            <table class="table table-hover table-striped table-borderless border-0" style="border-left: 0; border-right: 0">
                                                                <thead>
                                                                <tr>
                                                                    <th class="text-nowrap">
                                                                        <div class="text-weight-bold">Challenge Name</div>
                                                                        <div class="text-weight-bold">&nbsp;</div>
                                                                    </th>
                                                                    <th class="text-nowrap">
                                                                        <div class="text-weight-bold">Accuracy</div>
                                                                        <div class="text-weight-bold">(%)</div>
                                                                    </th>
                                                                    <th class="text-nowrap">
                                                                        <div class="text-weight-bold">Competency</div>
                                                                        <div class="text-weight-bold">(%)</div>
                                                                    </th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>

                                                                <tr *ngFor="let d of scorecard.individualChallenges;  index as i">
                                                                    <td class="text-nowrap" style="color: #000;"> {{d.challengeName}}</td>
                                                                    <td class="text-nowrap" style="color: #000;"> {{d.accuracy}}</td>
                                                                    <td class="text-nowrap " style="color: #000;"> {{d.competency}}</td>
                                                                </tr>

                                                                </tbody>
                                                            </table>
                                                        </ng-container>
                                                        <ng-template #targetIndividual>
                                                            <div style="height: 100px; display: flex; justify-content: center; align-items: center;" class="text-grey">No data recorded yet</div>
                                                        </ng-template>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                                <div class="table-responsive table-wrapper-bordered" style="border-radius: 10px; border: none">
                                                    <h4 class="py-3 px-3">Challenge Wide Match</h4>
                                                    <div class="table-responsive table-wrapper-bordered mx-2">
                                                        <ng-container *ngIf="scorecard && scorecard.wideMatches && scorecard.wideMatches.length > 0; else targetWideMatch">
                                                            <table class="table table-hover table-striped table-borderless border-0" style="border-left: 0; border-right: 0">
                                                                <thead>
                                                                <tr>
                                                                    <th class="text-nowrap">
                                                                        <div class="text-weight-bold">Challenge Name</div>
                                                                        <div class="text-weight-bold">&nbsp;</div>
                                                                    </th>
                                                                    <th class="text-nowrap">
                                                                        <div class="text-weight-bold">Average</div>
                                                                        <div class="text-weight-bold">Accuracy (%)</div>
                                                                    </th>
                                                                    <th class="text-nowrap">
                                                                        <div class="text-weight-bold">Average</div>
                                                                        <div class="text-weight-bold">Competency (%)</div>
                                                                    </th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>

                                                                <tr *ngFor="let d of scorecard.wideMatches;  index as i">
                                                                    <td class="text-nowrap" style="color: #000;"> {{d.challengeName}}</td>
                                                                    <td class="text-nowrap" style="color: #000;"> {{d.averageAccuracy}}</td>
                                                                    <td class="text-nowrap" style="color: #000;"> {{d.averageCompetency}}</td>
                                                                </tr>


                                                                </tbody>
                                                            </table>
                                                        </ng-container>
                                                        <ng-template #targetWideMatch>
                                                            <div style="height: 100px; display: flex; justify-content: center; align-items: center;" class="text-grey">No data recorded yet</div>
                                                        </ng-template>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
